import React from 'react'

import FormUnControlled from 'common/Forms/Base/FormUnControlled'
import Input from 'common/Input'

export default props => <FormUnControlled tag={Input} {...props} />
